import { render, staticRenderFns } from "./SwdaPeiAnnualReturns.vue?vue&type=template&id=39955f54&scoped=true"
import script from "./SwdaPeiAnnualReturns.vue?vue&type=script&lang=js"
export * from "./SwdaPeiAnnualReturns.vue?vue&type=script&lang=js"
import style0 from "./SwdaPeiAnnualReturns.vue?vue&type=style&index=0&id=39955f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39955f54",
  null
  
)

export default component.exports